import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminProductWorksNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('product-work');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
